import { Game } from "speakid-hangman";
import PersonalDefaultPage from "../personal/PersonalDefaultPage";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Config from "../../Config";
import axios from "axios";
import { useWindowDimensions } from "../../utils";

export default function Hangman() {
  const navigate = useNavigate();
  const {width: screenWidth, height: screenHeight} = useWindowDimensions();
  
  // Fallback значения если useWindowDimensions вернул undefined
  const width = screenWidth || (typeof window !== 'undefined' ? window.innerWidth : 1366);
  const height = screenHeight || (typeof window !== 'undefined' ? window.innerHeight : 768);
  
  // Получаем реальное разрешение экрана для правильной категоризации
  // Это важно при системном zoom Windows (например, 150%)
  const realScreenWidth = typeof window !== 'undefined' && window.screen ? window.screen.width : width;
  const realScreenHeight = typeof window !== 'undefined' && window.screen ? window.screen.height : height;

  // 🔍 ОТЛАДКА - временно
  console.log('🔍 Hangman Debug:');
  console.log('  screenWidth:', screenWidth);
  console.log('  screenHeight:', screenHeight);
  console.log('  width (с fallback):', width);
  console.log('  height (с fallback):', height);
  console.log('  realScreenWidth:', realScreenWidth);
  console.log('  realScreenHeight:', realScreenHeight);
  console.log('  window.screen.width:', typeof window !== 'undefined' && window.screen ? window.screen.width : 'N/A');
  console.log('  window.screen.height:', typeof window !== 'undefined' && window.screen ? window.screen.height : 'N/A');
  console.log('  window.innerWidth:', typeof window !== 'undefined' ? window.innerWidth : 'N/A');
  console.log('  window.innerHeight:', typeof window !== 'undefined' ? window.innerHeight : 'N/A');

  // ✅ Улучшенная логика размеров игры
  let gameCubeSize = 400;
  
  if (width < 768) {
    console.log('  ✅ Категория: Мобилки');
    // Мобилки: используем почти всю ширину с небольшими отступами
    gameCubeSize = width - 20;
  } else if (width < 1200) {
    console.log('  ✅ Категория: Планшеты/маленькие ноутбуки');
    // Планшеты и маленькие ноутбуки: адаптивный размер
    gameCubeSize = Math.min(width, height) - 60;
  } else if (realScreenWidth <= 1400) {
    console.log('  ✅ Категория: До 1400px (наша логика!)');
    // Для разрешений до 1400px используем ту же логику что и для десктопов
    // но с правильным учетом всех отступов
    const paddingTop = width > 1420 ? 25 : 68;
    const availableHeight = height - paddingTop - 25 - 25;
    // ✅ ИСПРАВЛЕНО: минимум 600px чтобы интерфейс влазил даже при маленькой высоте браузера
    // (браузер занимает не весь экран из-за панелей, адресной строки и т.д.)
    gameCubeSize = Math.max(Math.min(1000, availableHeight), 600);
    console.log('  paddingTop:', paddingTop);
    console.log('  availableHeight:', availableHeight);
    console.log('  gameCubeSize (до ограничений):', gameCubeSize);
  } else {
    console.log('  ✅ Категория: Десктопы');
    // Десктопы: фиксированный комфортный размер
    gameCubeSize = Math.min(1000, height - 100);
  }
  
  // ✅ Минимальные ограничения для читаемости
  gameCubeSize = Math.max(gameCubeSize, 320); // минимум для мобилок
  gameCubeSize = Math.min(gameCubeSize, 1200); // максимум для больших экранов
  
  console.log('  🎯 Итоговый gameCubeSize:', gameCubeSize);
  console.log('  📤 Передаем в Game компонент:');
  console.log('    gameCubeSize:', gameCubeSize);
  console.log('    screenHeight:', height);
  console.log('    screenWidth:', width);
  console.log('    realScreenWidth:', realScreenWidth);
  console.log('    realScreenHeight:', realScreenHeight);
  console.log('    baseURL:', window.origin + "/cloud/speakid/games/hangman");
  console.log('    showLogo:', true);
  console.log('    Категория по realScreenWidth:', realScreenWidth <= 1400 ? '<= 1400px' : '> 1400px');
  console.log('    Соотношение width/height:', (width / height).toFixed(2));
  console.log('    Соотношение realScreenWidth/realScreenHeight:', (realScreenWidth / realScreenHeight).toFixed(2));
  
  useEffect(() => {
    let backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod"
    axios.get(backendAddr).then(response => {
      if (response.status === 200) {
        if (response.data.status === "not_paid") {
          navigate("/billing/");
        }
      }
    }).catch(err => {
      console.warn("Ошибка проверки подписки в БД! ", err)
    })
  }, [navigate]);
  
  return (
    <PersonalDefaultPage>
      {realScreenWidth <= 1400 ? (
        <div style={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Game 
            gameCubeSize={gameCubeSize} 
            screenHeight={height} 
            screenWidth={width}
            baseURL={window.origin + "/cloud/speakid/games/hangman"}
            showLogo={true}
          />
        </div>
      ) : (
        <Game 
          gameCubeSize={gameCubeSize} 
          screenHeight={height} 
          screenWidth={width}
          baseURL={window.origin + "/cloud/speakid/games/hangman"}
          showLogo={true}
        />
      )}
    </PersonalDefaultPage>
  );
}